import React, {useEffect} from 'react';
import {Col, Container, Row} from "react-bootstrap";

import {useCheckAuth} from "../../../Hooks/RouteHooks";

import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";
import {PageNavigator} from "./PageNavigator";
import {RESET_PARAMETERS} from "../../../Redux/Actions/Types";
import {useDispatch} from "react-redux";
import {useQueryParams} from "../../../../../monitoring/src/Hooks/RouteHooks"


export const ReportBuilderIndexPage = props => {
    useCheckAuth();
    useContextIndependentPage(props);

    const dispatch = useDispatch();
    const classNames = useClassNames('sb-report-builder-index-page');

    const title = 'Report Builder';
    
    const {reportTypeId = 4, projectId, phaseId, procedureId = 8, monitoringEventId } = useQueryParams();

    useEffect(() => {
        dispatch({type: RESET_PARAMETERS, parameters: { reportTypeId, projectId, phaseId, procedureId, monitoringEventId } });
    }, []);

    return <Container className={classNames}>
        <div className="sb-print-show w-100">
            <div className="d-flex justify-content-center">
                <img src="/img/sba-logo-black.svg" className="report-logo" />
            </div>
        </div>
        <StreamBankPageHeader
            Title={title}
        />
        <PageNavigator title={title} />
    </Container>;
};


